/* eslint-disable @nx/enforce-module-boundaries */
import { AuthGuard } from '@kanzi-apes/kanzi-auth';
import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { canMatchFn, canActivateFn } from '@kanzi-apes/kanzi-authenticator';
import { importProvidersFrom } from '@angular/core';
import * as LocationState from '@kanzi-apes/kanzi-locations';
import { StoreModule } from '@ngrx/store';

import { LayoutMainViewComponent } from './components/layout-main-view/layout-main-view.component';

const kanziTitle = 'Kanzi WMS';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    providers: [
      importProvidersFrom(
        StoreModule.forFeature(
          LocationState.LOCATIONS_FEATURE_KEY,
          LocationState.locationsReducer
        )
      ),
    ],
    title: kanziTitle,
    data: {
      breadcrumb: 'menu_breadcrumb.home',
    },
    canActivate: [canActivateFn],
    children: [
      {
        path: '',
        component: LayoutMainViewComponent,
      },
      {
        path: 'replenishment',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-wms-replenishment').then(
            (m) => m.kanziReplenishmentWmsRoutes
          ),
        title: kanziTitle + ' - Replenishment',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.replenishment',
        },
      },
      {
        path: 'data-loader',
        title: kanziTitle + ' - Data Loader',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.dataloader',
        },
        loadComponent: () =>
          import('@kanzi-apes/kanzi-data-loader-wms').then(
            (m) => m.KanziDataLoaderWmsComponent
          ),
      },
      {
        path: 'administration',
        title: kanziTitle + ' - Administration',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.administration',
        },
        children: [
          {
            path: 'users',
            loadChildren: () =>
              import('@kanzi-apes/kanzi-wms-users').then(
                (m) => m.kanziWmsUsersAdministrationRoutes
              ),
            title: kanziTitle + ' - Users',
            canMatch: [canMatchFn],
            data: {
              breadcrumb: 'menu_breadcrumb.users',
            },
          },
          {
            path: 'locations',
            loadChildren: () =>
              import('@kanzi-apes/kanzi-locations').then(
                (m) => m.kanziLocationManagementRoutes
              ),
            title: kanziTitle + ' - Locations',
            canMatch: [canMatchFn],
            data: {
              breadcrumb: 'menu_breadcrumb.locations',
            },
          },
          {
            path: 'containers',
            loadChildren: () =>
              import('@kanzi-apes/kanzi-wms-containers').then(
                (m) => m.kanziWmsContainersRoutes
              ),
            title: kanziTitle + ' - Containers',
            canMatch: [canMatchFn],
            data: {
              breadcrumb: 'menu_breadcrumb.containers',
            },
          },
        ],
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-wms-users').then(
            (m) => m.kanziWmsUsersRoutes
          ),
        title: kanziTitle + ' - Users',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.users',
        },
      },
      {
        path: 'third-parties',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-contacts').then(
            (m) => m.kanziThirdPartiesRoutes
          ),
        title: kanziTitle + ' - Third Parties',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.thirds',
        },
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-products').then(
            (m) => m.kanziProductsRoutes
          ),
        title: kanziTitle + ' - Products',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.products',
        },
      },
      {
        path: 'operations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-operations-wms').then(
            (m) => m.kanziOperationsWmsRoutes
          ),
        title: kanziTitle + ' - Operations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.orders',
        },
      },
      {
        path: 'reception',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-reception-wms').then(
            (m) => m.kanziReceptionWmsRoutes
          ),
        title: kanziTitle + ' - Reception',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.receiving',
        },
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-inventory-wms').then(
            (m) => m.kanziInventoryCountsWmsRoutes
          ),
        title: kanziTitle + ' - Inventory',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventory_list',
        },
      },
      {
        path: 'planning',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-planning-wms').then(
            (m) => m.kanziPlanningWmsRoutes
          ),
        title: kanziTitle + ' - Planning',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.planning',
        },
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-analytics-reports').then(
            (m) => m.KanziAnalyticsReportsModule
          ),
        title: kanziTitle + ' - Analytics',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.analytics',
        },
      },
      {
        path: 'apps',
        canMatch: [canMatchFn],
        children: [
          {
            path: 'webhooks',
            loadChildren: () =>
              import('@kanzi-apes/kanzi-wms-webhooks').then(
                (m) => m.kanziWmsWebhooksRoutes
              ),
            title: kanziTitle + ' - Webhooks',
            canMatch: [canMatchFn],
            data: {
              breadcrumb: 'menu_breadcrumb.webhooks',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-authenticator').then(
        (m) => m.kanziAuthenticatorRoutes
      ),
    title: kanziTitle + ' - Login',
    providers: [],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
